import { TSeoData } from '../../types/redux/state';
import { EBuildersInfoActionTypes } from '../../actions/buildersInfo';
import { TReduxActions } from '../../types/redux';

export const seoDataReducer = (
  state: TSeoData = {
    title: '',
    description: '',
    keywords: '',
    h1: '',
    noindex: false,
  },
  action: TReduxActions,
) => {
  switch (action.type) {
    case EBuildersInfoActionTypes.Success:
      return { ...action.payload.seoData };

    default:
      return state;
  }
};
